import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let refreshTreatmentPlanNotes = useDataChange({
    context: 'refresh',
    path: 'treatment_plan_notes',
    viewPath: props.viewPath,
  })

  return function onClick() {
    refreshTreatmentPlanNotes(Date.now())
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
